import { useParams } from "react-router-dom";

import { useAssetRepositoryId } from "hooks/queries/useOwnCompany";

export default function useFolderIdParam() {
  const { data: assetRepositoryId } = useAssetRepositoryId();
  return useParams<{ folderId: string }>().folderId || assetRepositoryId;
}
